{
  "new-app-version-notification": {
    "buttons": {
      "update": "Aktualisieren"
    },
    "text": {
      "new-version-available": "Neue Version ist verfügbar"
    }
  }
}
